// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-page {
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  padding: 0 10px 32px 10px;
  background: #f7f9fa;
}

.section-title {
  margin: 20px 0 18px 0;
  font-size: 1.32rem;
  font-weight: 800;
  color: #232137;
  letter-spacing: -0.02em;
}

.section-subtitle {
  margin: 0 0 12px 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #232137;
}

.section-toolbar {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.section-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 3px 18px rgba(36, 41, 57, 0.08);
  padding: 16px 14px;
  margin-bottom: 14px;
}

.section-card-nested {
  margin-bottom: 0;
  padding: 12px;
  background: #f8fafc;
  box-shadow: none;
}

.section-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.section-stat {
  background: #f6f8fb;
  border-radius: 14px;
  padding: 12px 11px;
  min-width: 0;
}

.section-stat-label {
  font-size: 0.86rem;
  color: #7d8ca6;
  margin-bottom: 6px;
}

.section-stat-value {
  font-size: 1.04rem;
  font-weight: 800;
  color: #232137;
  overflow-wrap: anywhere;
}

.section-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.section-label {
  font-size: 0.93rem;
  font-weight: 700;
  color: #232137;
}

.section-input,
.section-select,
.section-textarea {
  width: 100%;
  border-radius: 13px;
  border: 1px solid #e1e6f0;
  background: #fbfcfe;
  color: #232137;
  font-size: 0.98rem;
  padding: 12px 13px;
  outline: none;
  transition: border-color 0.15s ease, background 0.15s ease;
  box-sizing: border-box;
}

.section-input:focus,
.section-select:focus,
.section-textarea:focus {
  border-color: #e72f44;
  background: #fff;
}

.section-textarea {
  min-height: 110px;
  resize: vertical;
}

.section-inline {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.section-inline > * {
  flex: 1 1;
  min-width: 120px;
}

.section-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.section-btn,
.section-btn-secondary,
.section-btn-danger {
  border: none;
  border-radius: 14px;
  font-size: 0.97rem;
  font-weight: 700;
  padding: 12px 15px;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;
}

.section-btn {
  background: #e72f44;
  color: #fff;
}

.section-btn-secondary {
  background: #eef2f7;
  color: #232137;
}

.section-btn-danger {
  background: #fff0f2;
  color: #c61f35;
}

.section-btn:disabled,
.section-btn-secondary:disabled,
.section-btn-danger:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.section-empty,
.section-error,
.section-success {
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 0.96rem;
  margin-bottom: 14px;
}

.section-empty {
  background: #fff;
  color: #7d8ca6;
}

.section-error {
  background: #fff0f2;
  color: #b51d31;
}

.section-success {
  background: #eefaf1;
  color: #22753a;
}

.section-chip-list {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.section-chip {
  border: 1px solid #e1e6f0;
  border-radius: 999px;
  background: #fff;
  color: #232137;
  font-size: 0.9rem;
  padding: 7px 10px;
  cursor: pointer;
}

.section-chip.active {
  background: #e72f44;
  border-color: #e72f44;
  color: #fff;
}

.section-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.section-item {
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 2px 12px rgba(36, 41, 57, 0.07);
  padding: 14px 13px;
  border: none;
  width: 100%;
  min-width: 0;
  text-align: left;
}

.section-item-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
  min-width: 0;
}

.section-item-head > * {
  min-width: 0;
}

.section-item-head > :first-child {
  flex: 1 1 auto;
}

.section-item-title {
  font-size: 1rem;
  font-weight: 700;
  color: #232137;
  overflow-wrap: anywhere;
}

.section-item-meta {
  font-size: 0.87rem;
  color: #7d8ca6;
  overflow-wrap: anywhere;
}

.section-badge {
  border-radius: 999px;
  padding: 5px 9px;
  font-size: 0.82rem;
  font-weight: 700;
  white-space: normal;
  max-width: 50%;
  min-width: 0;
  flex: 0 1 auto;
  text-align: center;
  overflow-wrap: anywhere;
}

.section-badge.success {
  background: #eaf8ed;
  color: #1c8341;
}

.section-badge.warning {
  background: #fff7de;
  color: #946c00;
}

.section-badge.neutral {
  background: #eef2f7;
  color: #556074;
}

.section-upload-list {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.section-upload-row {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  background: #f6f8fb;
  border-radius: 12px;
  padding: 9px 11px;
}

.section-upload-name {
  min-width: 0;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.92rem;
  color: #232137;
}

.section-upload-remove {
  border: none;
  background: transparent;
  color: #c61f35;
  font-size: 1rem;
  cursor: pointer;
}

.section-upload-remove:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.section-upload-progress {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-height: 57px;
  padding: 2px 0 5px;
}

.section-upload-progress-heading,
.section-upload-progress-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.section-upload-progress-heading {
  color: #232137;
  font-size: 0.92rem;
}

.section-upload-progress-heading strong {
  flex: 0 0 42px;
  text-align: right;
}

.section-upload-progress-track {
  position: relative;
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #e1e6f0;
}

.section-upload-progress-fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #e72f44;
  transition: width 0.2s ease;
}

.section-upload-progress-file {
  min-width: 0;
  color: #7d8ca6;
  font-size: 0.84rem;
}

.section-upload-progress-file span:first-child {
  flex: 0 0 auto;
}

.section-upload-progress-file span:last-child {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
  white-space: nowrap;
}

.section-helper {
  font-size: 0.84rem;
  color: #7d8ca6;
}

.section-table {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.section-table-row {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);
  gap: 8px;
  padding: 10px 0;
  border-bottom: 1px solid #edf1f6;
}

.section-table-row:last-child {
  border-bottom: none;
}

.section-table-key {
  font-size: 0.9rem;
  color: #7d8ca6;
  min-width: 0;
  overflow-wrap: anywhere;
}

.section-table-value {
  text-align: right;
  font-size: 0.92rem;
  color: #232137;
  font-weight: 600;
  min-width: 0;
  overflow-wrap: anywhere;
}

.section-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.section-item-text {
  font-size: 0.92rem;
  color: #516072;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.section-metric {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.92rem;
  color: #516072;
}

.section-metric strong {
  color: #232137;
  min-width: 0;
  text-align: right;
  overflow-wrap: anywhere;
}

.section-checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.section-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid #e1e6f0;
  border-radius: 12px;
  background: #fff;
  padding: 10px 12px;
  color: #232137;
  font-size: 0.94rem;
}

.section-checkbox input {
  margin-top: 2px;
}

.section-checkbox-text {
  display: grid;
  gap: 5px;
  min-width: 0;
  line-height: 1.25;
}

.section-priority-note {
  align-self: flex-start;
  border: 1px solid #fecdd3;
  border-radius: 999px;
  background: #fff1f2;
  color: #be123c;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1.2;
  padding: 3px 8px;
  overflow-wrap: anywhere;
}

@media (max-width: 520px) {
  .section-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .section-input,
  .section-select,
  .section-textarea {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/shared/mobileSection.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,6CAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AACF;;AAEA;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;;;EAGE,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,0DAAA;EACA,sBAAA;AACF;;AAEA;;;EAGE,qBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;;;EAGE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,uEAAA;AACF;;AAEA;EACE,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;;;EAGE,aAAA;EACA,mBAAA;AACF;;AAEA;;;EAGE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;EACA,6CAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;AACF;;AAEA;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,sDAAA;EACA,QAAA;EACA,eAAA;EACA,gCAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE;IACE,gDAAA;EACF;EAEA;;;IAGE,eAAA;EAAF;AACF","sourcesContent":[".section-page {\n  max-width: 480px;\n  margin: 0 auto;\n  min-height: 100vh;\n  padding: 0 10px 32px 10px;\n  background: #f7f9fa;\n}\n\n.section-title {\n  margin: 20px 0 18px 0;\n  font-size: 1.32rem;\n  font-weight: 800;\n  color: #232137;\n  letter-spacing: -0.02em;\n}\n\n.section-subtitle {\n  margin: 0 0 12px 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #232137;\n}\n\n.section-toolbar {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.section-card {\n  background: #fff;\n  border-radius: 18px;\n  box-shadow: 0 3px 18px rgba(36, 41, 57, 0.08);\n  padding: 16px 14px;\n  margin-bottom: 14px;\n}\n\n.section-card-nested {\n  margin-bottom: 0;\n  padding: 12px;\n  background: #f8fafc;\n  box-shadow: none;\n}\n\n.section-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.section-stat {\n  background: #f6f8fb;\n  border-radius: 14px;\n  padding: 12px 11px;\n  min-width: 0;\n}\n\n.section-stat-label {\n  font-size: 0.86rem;\n  color: #7d8ca6;\n  margin-bottom: 6px;\n}\n\n.section-stat-value {\n  font-size: 1.04rem;\n  font-weight: 800;\n  color: #232137;\n  overflow-wrap: anywhere;\n}\n\n.section-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.section-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.section-label {\n  font-size: 0.93rem;\n  font-weight: 700;\n  color: #232137;\n}\n\n.section-input,\n.section-select,\n.section-textarea {\n  width: 100%;\n  border-radius: 13px;\n  border: 1px solid #e1e6f0;\n  background: #fbfcfe;\n  color: #232137;\n  font-size: 0.98rem;\n  padding: 12px 13px;\n  outline: none;\n  transition: border-color 0.15s ease, background 0.15s ease;\n  box-sizing: border-box;\n}\n\n.section-input:focus,\n.section-select:focus,\n.section-textarea:focus {\n  border-color: #e72f44;\n  background: #fff;\n}\n\n.section-textarea {\n  min-height: 110px;\n  resize: vertical;\n}\n\n.section-inline {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.section-inline > * {\n  flex: 1 1 0;\n  min-width: 120px;\n}\n\n.section-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.section-btn,\n.section-btn-secondary,\n.section-btn-danger {\n  border: none;\n  border-radius: 14px;\n  font-size: 0.97rem;\n  font-weight: 700;\n  padding: 12px 15px;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;\n}\n\n.section-btn {\n  background: #e72f44;\n  color: #fff;\n}\n\n.section-btn-secondary {\n  background: #eef2f7;\n  color: #232137;\n}\n\n.section-btn-danger {\n  background: #fff0f2;\n  color: #c61f35;\n}\n\n.section-btn:disabled,\n.section-btn-secondary:disabled,\n.section-btn-danger:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.section-empty,\n.section-error,\n.section-success {\n  border-radius: 14px;\n  padding: 12px 14px;\n  font-size: 0.96rem;\n  margin-bottom: 14px;\n}\n\n.section-empty {\n  background: #fff;\n  color: #7d8ca6;\n}\n\n.section-error {\n  background: #fff0f2;\n  color: #b51d31;\n}\n\n.section-success {\n  background: #eefaf1;\n  color: #22753a;\n}\n\n.section-chip-list {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.section-chip {\n  border: 1px solid #e1e6f0;\n  border-radius: 999px;\n  background: #fff;\n  color: #232137;\n  font-size: 0.9rem;\n  padding: 7px 10px;\n  cursor: pointer;\n}\n\n.section-chip.active {\n  background: #e72f44;\n  border-color: #e72f44;\n  color: #fff;\n}\n\n.section-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.section-item {\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 2px 12px rgba(36, 41, 57, 0.07);\n  padding: 14px 13px;\n  border: none;\n  width: 100%;\n  min-width: 0;\n  text-align: left;\n}\n\n.section-item-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 8px;\n  min-width: 0;\n}\n\n.section-item-head > * {\n  min-width: 0;\n}\n\n.section-item-head > :first-child {\n  flex: 1 1 auto;\n}\n\n.section-item-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #232137;\n  overflow-wrap: anywhere;\n}\n\n.section-item-meta {\n  font-size: 0.87rem;\n  color: #7d8ca6;\n  overflow-wrap: anywhere;\n}\n\n.section-badge {\n  border-radius: 999px;\n  padding: 5px 9px;\n  font-size: 0.82rem;\n  font-weight: 700;\n  white-space: normal;\n  max-width: 50%;\n  min-width: 0;\n  flex: 0 1 auto;\n  text-align: center;\n  overflow-wrap: anywhere;\n}\n\n.section-badge.success {\n  background: #eaf8ed;\n  color: #1c8341;\n}\n\n.section-badge.warning {\n  background: #fff7de;\n  color: #946c00;\n}\n\n.section-badge.neutral {\n  background: #eef2f7;\n  color: #556074;\n}\n\n.section-upload-list {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.section-upload-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: space-between;\n  background: #f6f8fb;\n  border-radius: 12px;\n  padding: 9px 11px;\n}\n\n.section-upload-name {\n  min-width: 0;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 0.92rem;\n  color: #232137;\n}\n\n.section-upload-remove {\n  border: none;\n  background: transparent;\n  color: #c61f35;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n.section-upload-remove:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.section-upload-progress {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  min-height: 57px;\n  padding: 2px 0 5px;\n}\n\n.section-upload-progress-heading,\n.section-upload-progress-file {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.section-upload-progress-heading {\n  color: #232137;\n  font-size: 0.92rem;\n}\n\n.section-upload-progress-heading strong {\n  flex: 0 0 42px;\n  text-align: right;\n}\n\n.section-upload-progress-track {\n  position: relative;\n  height: 8px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #e1e6f0;\n}\n\n.section-upload-progress-fill {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: #e72f44;\n  transition: width 0.2s ease;\n}\n\n.section-upload-progress-file {\n  min-width: 0;\n  color: #7d8ca6;\n  font-size: 0.84rem;\n}\n\n.section-upload-progress-file span:first-child {\n  flex: 0 0 auto;\n}\n\n.section-upload-progress-file span:last-child {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.section-helper {\n  font-size: 0.84rem;\n  color: #7d8ca6;\n}\n\n.section-table {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.section-table-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1.4fr) minmax(0, 1fr);\n  gap: 8px;\n  padding: 10px 0;\n  border-bottom: 1px solid #edf1f6;\n}\n\n.section-table-row:last-child {\n  border-bottom: none;\n}\n\n.section-table-key {\n  font-size: 0.9rem;\n  color: #7d8ca6;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.section-table-value {\n  text-align: right;\n  font-size: 0.92rem;\n  color: #232137;\n  font-weight: 600;\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.section-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.section-item-text {\n  font-size: 0.92rem;\n  color: #516072;\n  line-height: 1.45;\n  overflow-wrap: anywhere;\n}\n\n.section-metric {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  font-size: 0.92rem;\n  color: #516072;\n}\n\n.section-metric strong {\n  color: #232137;\n  min-width: 0;\n  text-align: right;\n  overflow-wrap: anywhere;\n}\n\n.section-checkbox-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.section-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  border: 1px solid #e1e6f0;\n  border-radius: 12px;\n  background: #fff;\n  padding: 10px 12px;\n  color: #232137;\n  font-size: 0.94rem;\n}\n\n.section-checkbox input {\n  margin-top: 2px;\n}\n\n.section-checkbox-text {\n  display: grid;\n  gap: 5px;\n  min-width: 0;\n  line-height: 1.25;\n}\n\n.section-priority-note {\n  align-self: flex-start;\n  border: 1px solid #fecdd3;\n  border-radius: 999px;\n  background: #fff1f2;\n  color: #be123c;\n  font-size: 0.78rem;\n  font-weight: 800;\n  line-height: 1.2;\n  padding: 3px 8px;\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 520px) {\n  .section-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .section-input,\n  .section-select,\n  .section-textarea {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
